import { AuthService } from '@/services/auth.service';
import type { User } from '@/types/domain/user';
import type { QueryClient } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';

export const authQueryKeys = {
  all: ['auth'] as const,
  profile: () => [...authQueryKeys.all, 'profile'] as const,
};

export const authQueryOptions = {
  profile: () =>
    queryOptions({
      queryKey: authQueryKeys.profile(),
      queryFn: () => AuthService.profile(),
      retry: false,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    }),
};

export async function refreshAuthProfileCache(queryClient: QueryClient, nextUser?: User | null) {
  const queryKey = authQueryKeys.profile();

  if (typeof nextUser !== 'undefined') {
    queryClient.setQueryData(queryKey, nextUser);
  }

  await queryClient.invalidateQueries({ queryKey });
  await queryClient.refetchQueries({ queryKey, type: 'active' });

  return queryClient.getQueryData<User | null>(queryKey) ?? null;
}
